// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ResourceSearchResult } from "../result/resource-search-result";
import { Gender } from "../../data/talent-core/gender";
import { Ethnicity } from "../../data/talent-core/ethnicity";
import { CharacterType } from "../../data/talent-core/character-type";
import { ActingProfileDocument } from "./documents/acting-profile-document";
import { ItemEnvelope } from "./base/item-envelope";

export class ActingProfileEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "ActingProfile");
		if (jsonEnvelope) {
			this.Resources = jsonEnvelope.Resources;
			this.Genders = jsonEnvelope.Genders;
			this.Ethnicities = jsonEnvelope.Ethnicities;
			this.CharacterTypes = jsonEnvelope.CharacterTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public Resources: ResourceSearchResult[] = [];
	public Genders: Gender[] = [];
	public Ethnicities: Ethnicity[] = [];
	public CharacterTypes: CharacterType[] = [];
	public override Document: ActingProfileDocument = new ActingProfileDocument();
	public override get ItemId(): number { return this.Document.Item.ActingProfileId; }
	public override get ItemName(): string { return this.Document.Item.Name; }
}